import { createIcon } from '@chakra-ui/icons';

export const CalendarCheckOut = createIcon({
  displayName: 'CalendarCheckOut',
  viewBox: '0 0 16 16',
  path: [
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.6663 1.33337V4.00004M5.33301 1.33337V4.00004"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14 9.99996V7.99996C14 5.4858 14 4.22872 13.219 3.44767C12.4379 2.66663 11.1808 2.66663 8.66667 2.66663H7.33333C4.81918 2.66663 3.5621 2.66663 2.78105 3.44767C2 4.22872 2 5.4858 2 7.99996V9.33329C2 11.8475 2 13.1045 2.78105 13.8856C3.5621 14.6666 4.81918 14.6666 7.33333 14.6666H8"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 6.66663H14"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12.333 14.6667C12.6701 14.339 13.9997 13.4669 13.9997 13C13.9997 12.5332 12.6701 11.6611 12.333 11.3334M13.6663 13H9.33301"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>,
  ],
});
